// Erkennt In-App-WebViews (native App-Container) vs. echte Browser-Tabs.
//
// Zweck: das Schliessen-X im Viewer NUR in der nativen App ausblenden (die App
// bringt dort ihr eigenes Schliessen — sonst „zwei Kreuzchen", Lauras Fund) und
// in JEDEM echten Browser zeigen (geteilter Link / Website-Container) — dort
// fuehrt das X auf die Org-Homepage.
//
// Belegt an echtem WESER-KURIER-App-Traffic (Ingress-Logs 2026-08-13, referer
// weser-kurier.de): die WK-App-WKWebView sendet den klassischen iOS-In-App-UA
//   "...(iPhone; CPU iPhone OS 18_7 ...) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148"
// OHNE `Safari/`- und `Version/`-Token — waehrend echtes iOS-Safari beide traegt
// ("... Version/26.5.2 ... Safari/604.1"). Genau daran haengt die Erkennung.
//
// Regeln:
//  - Android-App-WebView: UA enthaelt das `wv`-Token (Standard-Android-WebView).
//  - iOS-App-WKWebView: iPhone/iPad/iPod, aber KEIN echter iOS-Browser-Token
//    (echtes Safari + Chrome/CriOS + Firefox/FxiOS + Edge/EdgiOS + Opera/OPiOS
//    tragen alle `Safari/`).
//  - Zusaetzlich harte Tokens bekannter Kunden-Apps als Sicherheitsgurt gegen
//    UA-Faelschung (erweiterbar).

const KNOWN_APP_UA_TOKENS = /WeserKurier|Weser-Kurier|WKApp/i;

export function isInAppWebView(ua?: string | null): boolean {
  if (!ua || typeof ua !== "string") return false;
  if (KNOWN_APP_UA_TOKENS.test(ua)) return true;
  // Android-WebView
  if (/Android/i.test(ua) && /\bwv\b/.test(ua)) return true;
  // iOS-In-App-WKWebView: iOS-Geraet ohne echten Browser-Token
  if (/\b(iPhone|iPad|iPod)\b/.test(ua)) {
    const echterIosBrowser =
      /Safari\//.test(ua) ||
      /CriOS\//.test(ua) ||
      /FxiOS\//.test(ua) ||
      /EdgiOS\//.test(ua) ||
      /OPiOS\//.test(ua);
    if (!echterIosBrowser) return true;
  }
  return false;
}
